export const DYNAMIC_TRIGGER = {
  business_footer: "business_footer",
  see_plan: "see_plan",
  seasonal_holiday_templates: "seasonal_holiday_templates",
  sidebar_product_page: "sidebar_product_page",
  sidebar_collection_page: "sidebar_collection_page",
  sidebar_blog_page: "sidebar_blog_page",
  option_product_page: "option_product_page",
  option_collection_page: "option_collection_page",
  option_article_page: "option_article_page",
  ab_testing_campaign: "ab_testing_campaign"
};

export const PATH_IDS_PRICING_ONBOARD = {
  product: "product",
  collection: "collection",
  ab_testing: "ab-testing",
  blog: "blog"
};
